import styled from 'styled-components';
import { color, fontSize, radius, spacing } from '../../../theme';

export const StyledWhereSpaces = styled.div`
  padding-bottom: ${spacing('xl4')};
  background-color: ${color('midnight_900')};
  border-radius: ${radius('lg')};
  color: ${color('text_default_inverse')};

  .slick-slider {
    padding-bottom: 0;
  }

  .slick-dots {
    bottom: -${spacing('xl')};

    li button {
      background-color: ${color('black')};
      border-color: ${color('midnight_700')};

      &:hover {
        border-color: ${color('midnight_200')};
      }
    }

    li.slick-active button {
      border-color: ${color('active')};
      background-color: ${color('active')};
    }
  }
`;

export const StyledWhereSpacesSlide = styled.figure`
  border-top-left-radius: ${radius('lg')};
  border-top-right-radius: ${radius('lg')};
  overflow: hidden;
  margin: 0;
  margin-top: -1px;
`;

export const StyledWhereSpacesSlideImg = styled.img`
  display: block;
  border-top-left-radius: ${radius('lg')};
  border-top-right-radius: ${radius('lg')};
  height: 21rem;
  width: 100%;
  object-fit: cover;
  margin-top: -0.5px;
`;

export const StyledWhereSpacesSlideCaption = styled.figcaption`
  background-color: ${color('midnight_850')};
  font-size: ${fontSize('sm')};
  line-height: 1.14;
  padding: ${spacing('md')};
  display: flex;
  text-align: left;

  svg {
    width: ${spacing('md')};
    height: ${spacing('md')};
    margin-right: ${spacing('xs')};
    color: ${color('emerald_600')};
  }
`;
